import React from "react";
import { motion } from "framer-motion";
import { formatAmount } from "../../utils/tableUtils";
import styles from "../../pages/css/Dashboard.module.css";

const StatCardsRow = ({
  dashboardData,
  isLoading,
  statContainerVariants,
  statCardVariants,
  textFadeUpVariants,
}) => {
  return (
    <motion.div
      className={`row g-3 ${styles.statRowWrapper}`}
      variants={statContainerVariants}
      initial="hidden"
      animate={isLoading ? "hidden" : "visible"}
    >
      {/* Card 1: Total Balance */}
      <motion.div className="col-12 col-sm-6 col-lg-3" variants={statCardVariants}>
        <div className={styles.dashboardStatCard}>
          <div className={styles.statCardContent}>
            <div className={styles.statTextGroup}>
              <div className={styles.statLabel}>Total Balance</div>
              <motion.div className={styles.statValue} variants={textFadeUpVariants}>
                {formatAmount(dashboardData?.walletBalance)}
              </motion.div>
              <div className={`${styles.statTrend} ${styles.statTrendSuccess}`}>
                <i className="fas fa-arrow-up me-1"></i> Live Wallet Sync
              </div>
            </div>
            <div className={styles.statIconBadge}>
              <i className="fas fa-wallet"></i>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Card 2: Tx Count */}
      <motion.div className="col-12 col-sm-6 col-lg-3" variants={statCardVariants}>
        <div className={styles.dashboardStatCard}>
          <div className={styles.statCardContent}>
            <div className={styles.statTextGroup}>
              <div className={styles.statLabel}>Tx Count</div>
              <motion.div className={styles.statValue} variants={textFadeUpVariants}>
                {dashboardData?.depositCount ?? 0}
              </motion.div>
              <div className={`${styles.statTrend} ${styles.statTrendNeutral}`}>
                <i className="fas fa-sync-alt me-1"></i> Total Processed
              </div>
            </div>
            <div className={styles.statIconBadge}>
              <i className="fas fa-exchange-alt"></i>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Card 3: Deposited Amount */}
      <motion.div className="col-12 col-sm-6 col-lg-3" variants={statCardVariants}>
        <div className={styles.dashboardStatCard}>
          <div className={styles.statCardContent}>
            <div className={styles.statTextGroup}>
              <div className={styles.statLabel}>Deposited Amount</div>
              <motion.div className={styles.statValue} variants={textFadeUpVariants}>
                {formatAmount(dashboardData?.totalDeposit)}
              </motion.div>
              <div className={`${styles.statTrend} ${styles.statTrendSuccess}`}>
                <i className="fas fa-arrow-up me-1"></i> Verified Total
              </div>
            </div>
            <div className={styles.statIconBadge}>
              <i className="fas fa-arrow-down"></i>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Card 4: Gateway Status */}
      <motion.div className="col-12 col-sm-6 col-lg-3" variants={statCardVariants}>
        <div className={styles.dashboardStatCard}>
          <div className={styles.statCardContent}>
            <div className={styles.statTextGroup}>
              <div className={styles.statLabel}>Gateway Status</div>
              <motion.div
                className={styles.statValue}
                style={{ fontSize: "1.35rem", display: "flex", alignItems: "center" }}
                variants={textFadeUpVariants}
              >
                <span className={styles.statusDot}></span>
                Active
              </motion.div>
              <div className={`${styles.statTrend} ${styles.statTrendSuccess}`}>
                <i className="fas fa-shield-alt me-1"></i> 100% Uptime
              </div>
            </div>
            <div className={styles.statIconBadge}>
              <i className="fas fa-check-circle"></i>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default StatCardsRow;
